const authTypes = {
  SIGNIN_REQUEST: "SIGNIN_REQUEST",
  SIGNIN_SUCCESS: "SIGNIN_SUCCESS",
  SIGNIN_FAILED: "SIGNIN_FAILED",
  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILED: "SIGNUP_FAILED",
  SIGNOUT: "SIGNOUT",
  RESET_ERROR: "RESET_ERROR",

  GET_ORDERS_REQUEST: "GET_ORDERS_REQUEST",
  GET_ORDERS_FAILED: "GET_ORDERS_FAILED",
  GET_ORDERS_SUCCESS: "GET_ORDERS_SUCCESS",

  ADD_ORDER_REQUEST: "ADD_ORDER_REQUEST",
  ADD_ORDER_FAILED: "ADD_ORDER_FAILED",
  ADD_ORDER_SUCCESS: "ADD_ORDER_SUCCESS",
};

export default authTypes;
